import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import { isEfModuleAllowedHandler, notifyUser } from "../../services/helpers";

import SubNavigation from "../../components/Header/SubNavigation";
import ExternalFlowConfigurationModal from "../../components/Modals/ExternalFlowConfigurationModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import ExternalFlowConfigurationTable from "../../components/Tables/ExternalFlowConfigurationTable";
import UserContext from "../../store/user-context";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";

const ExternalFlowConfiguration = () => {
  const [extFlowConfigs, setExtFlowConfigs] = useState(null);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editableExtFlowConfig, setEditableExtFlowConfig] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    getExternalFlowConfigurations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getExternalFlowConfigurations = () => {
    setIsLoading(true);
    sendApiRequest(
      "ExternalFlowConfiguration/GetExternalFlowConfigurations",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
        } else {
          setExtFlowConfigs(response.data.externalFlowConfigurations);
        }
        setIsLoading(false);
      }
    });
  };

  const modalOpenHandler = (extFlowConfig) => {
    setModalOpen(true);
    setEditableExtFlowConfig(extFlowConfig);
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
    getExternalFlowConfigurations();
    isEfModuleAllowedHandler(
      userContext.selectedClientFiscalCode,
      signIn,
      signOut,
      navigate,
      userContext,
      setError
    );
  };

  const confirmModalOpenHandler = (extFlowConfig) => {
    setEditableExtFlowConfig(extFlowConfig);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent =
        extFlowConfig.clientCodeName;
    }, 200);
    setConfirmModalOpen(true);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  return (
    <Fragment>
      <SubNavigation
        display={false}
        openModalHandler={modalOpenHandler}
        page="externalFlowConfiguration"
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <ExternalFlowConfigurationTable
            items={extFlowConfigs}
            columns={[
              {
                name: "Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCodeName",
              },
              {
                name: "Codice Tipologia Servizio",
                type: "string",
                sortable: true,
                value: "clientCode",
              },
              {
                name: "Formato",
                type: "string",
                sortable: false,
                value: "format",
              },
              {
                name: "Stato",
                type: "string",
                sortable: false,
                value: "status",
              },
              {
                name: "Azioni",
                type: "",
                sortable: false,
                value: "",
              },
            ]}
            openModalHandler={modalOpenHandler}
            confirmModalOpenHandler={confirmModalOpenHandler}
            getExternalFlowConfigurations={getExternalFlowConfigurations}
          />
        )}
      </Section>
      <ExternalFlowConfigurationModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        selectedClient={editableExtFlowConfig}
        setExtFlowConfigs={setExtFlowConfigs}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        notifyUser={notifyUser}
        clientId={editableExtFlowConfig.clientId}
        setExtFlowConfigs={setExtFlowConfigs}
        method={"deleteExternalFlowConfigurationHandler"}
        text={
          "Stai per eliminare la configurazione dei flussi esterni per la tipologia servizio selezionata"
        }
      />
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
      <Footer />
    </Fragment>
  );
};

export default ExternalFlowConfiguration;
